import store from '../store'

const TravellerDataFields = {
  install(Vue) {
    Vue.prototype.$UiConfig = function (parameter, defaultValue) {
      const UIConfiguration = store.getters.uiConfiguration;
      const value = getUiConfig(parameter, UIConfiguration);
      return value != null ? value : defaultValue;
    }
  }
}

function getUiConfig(parameter, UIConfiguration) {
  parameter = parameter ? removeLeadingSlash(parameter) : '';
  const value = parameter.split('/').reduce(function(prev, curr) {
    return prev ? prev[curr] : null;
  }, UIConfiguration );

  return value;
}

function removeLeadingSlash(parameter) {
  return parameter.replace(/^\//, '');
}

export default TravellerDataFields;